import {importDynamicModulesList} from "@nextories/vue-core-components/src/utils/helpers/format";

const coreFields = import.meta.glob('/node_modules/@nextories/vue-core-components/src/components/atoms/fields/*.vue', { eager: true });
const inputContainer = import.meta.glob('/node_modules/@nextories/vue-core-components/src/components/organisms/NxtCoreInputContainer.vue', { eager: true });
const fields = import.meta.glob('./organisms/fields/*.vue', { eager: true });

export default importDynamicModulesList([inputContainer, coreFields, fields]);
